export default {
  STEP_USER_NAME: 'userName',
  STEP_PASSWORD: 'password',
  STEP_SIGN_IN: 'signIn',
  STEP_ACTIVATION: 'activation',
  STEP_RECOVERY: 'recovery',
};
